import { authHeader, handleResponse } from '../helpers';

export const DistributorReportService = {
    getDistributorReport
};

function getDistributorReport(data) {

    console.log("Request Body:", data);

    const requestOptions = {
        method: 'POST',
        headers: {
            "Content-Type": "application/json",
            ...authHeader()
        },
        body: JSON.stringify(data)
    };

    return fetch(
        `${process.env.REACT_APP_API_URL}Distributor/GetDistributorReport`,
        requestOptions
    ).then(handleResponse);
}